import { Component, Inject, Input, OnChanges, OnInit, Optional, SimpleChanges } from '@angular/core';
import { WIDGET_DATA } from 'src/app/components/suggestions/suggestions.component';
import { ActivatedRoute, Router } from '@angular/router';
import { navigateWithFreshRoute } from 'src/app/shared/route-reuse.util';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BehaviorSubject } from 'rxjs';
import { CreditModelComponent } from 'src/app/components/credit/credit-model/credit-model.component';
import { countProvider } from 'src/app/components/suggestions/suggestions.component';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { CandidateService } from 'src/app/services/CandidateService';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { SearchData } from 'src/app/services/searchData';
import { UtilService } from 'src/app/services/util.service';
import { CommonModule } from '@angular/common';
import { CommonSkeletonComponent } from 'src/app/skeleton/common-skeleton/common-skeleton.component';
import { CommonProfileInfoComponent } from 'src/app/widget/common-profile-info/common-profile-info.component';
import { CandidateCardComponent } from 'src/app/components/cards/candidate-card/candidate-card.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-featured-candidate',
  standalone: true,
  imports: [
    CommonModule,
    CommonSkeletonComponent,
    CommonProfileInfoComponent,
CandidateCardComponent,
    InfiniteScrollModule
  ,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './featured-candidate.component.html',
  styleUrls: ['./featured-candidate.component.scss']
})
export class FeaturedCandidateComponent implements OnInit, OnChanges {
  response = new BehaviorSubject<any[]>([]);
  responseAfterkey : string = null;
  responseStopScroll : boolean = false;
  loadAPIcall : boolean = false;

  @Input() widgetDesc: string;
  @Input() suggestion: any;
  headerTitle: string = 'Featured Candidates';
  userType = localStorage.getItem('userType');
  candidatefilter
  totalCount: any;
  @Input() inputData: string;
  @Input() page: number;
  configlist = {
    itemsPerPage: 5,
    currentPage: 1
  }
  pathdata: any;
  @Input() maxMin: any = {};
  viewType: string = "MIN";
  obj: any = {
    limit: 10,
    searchAfterKey: null,
    createdBy: localStorage.getItem('userId')
  }
  sugges = null
  feaCandiCount: any;

  bsModalRef: BsModalRef;
  constructor(private a_route: ActivatedRoute, private modalService: BsModalService,
    private provider: countProvider, private router: Router, private apiService: ApiService,
    private candidateService : CandidateService , private util: UtilService, private searchdata: SearchData,
    @Optional() @Inject(WIDGET_DATA) private widgetData: any) {
    // Apply injected widget data (Angular 15 NgComponentOutlet pattern)
    if (this.widgetData) {
      if (this.widgetData.maxMin) {
        this.maxMin = this.widgetData.maxMin;
        if (this.widgetData.maxMin.viewType) {
          this.viewType = this.widgetData.maxMin.viewType;
        }
      }
      if (this.widgetData.widgetDesc) {
        this.headerTitle = this.widgetData.widgetDesc;
      }
      if (this.widgetData.inputData) {
        this.inputData = this.widgetData.inputData;
      }
      if (this.widgetData.page !== undefined) {
        this.page = this.widgetData.page;
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle maxMin changes - critical for showing MAX view on suggestions page
    if (changes.maxMin) {
      const newMaxMin = changes.maxMin.currentValue;
      if (newMaxMin) {
        this.maxMin = newMaxMin;
        if (newMaxMin.viewType) {
          this.viewType = newMaxMin.viewType;
        }
      }
    }
    // Handle widgetDesc changes for NgComponentOutlet compatibility
    if (changes.widgetDesc && changes.widgetDesc.currentValue) {
      this.headerTitle = changes.widgetDesc.currentValue;
    }
  }

  click: boolean;
  ngOnInit() {
    // Only set headerTitle if widgetDesc is provided (ngOnChanges handles dynamic updates)
    if (this.widgetDesc) {
      this.headerTitle = this.widgetDesc;
    }
    this.a_route.queryParams.subscribe((res) => {
      this.searchdata.getWidget().subscribe(res => {
        this.click = res;
      })

      this.candidatefilter = res.jobfilter;
      this.pathdata = res.count;
      if (res.master != "NETWORK" && res.master != "TEAM" && res.menu != null && res.menu != undefined) {
        this.headerTitle = res.menu;
      }
      this.totalCount = this.pathdata;
      if (this.maxMin.viewType != undefined) {
        this.viewType = "MAX";
        this.inputData = this.maxMin.master;
      }
      if (res.singleCandiF == "true") {
        this.getSingleCandi(res.id, false)
      }
      else {
        this.jobsApi();
      }
    })

    var a = this.a_route.pathFromRoot[0]['_routerState']['snapshot'].url
    var b = a.substring(0, 20)
    if (b == '/newcandidates?jobId') {
      this.candidatefilter = "true";
    } if (b == '/newjobs?candidateId') {
      this.candidatefilter = "true";
    }



  }

  refereshFeatureCandidates() {
    this.obj = {
      limit: 10,
      searchAfterKey:null,
      createdBy: localStorage.getItem('userId')
    }
    this.jobsApi()
  }


  resultContent: string = "";
  totalcandidates: number = 10;
  jobsApi() {

    if(this.response === undefined || Array.isArray(this.response)){
      this.response = new BehaviorSubject<any[]>([]);
    }

    this.loadAPIcall=true;
    this.apiService.create("candidates/findFeaturedCandidates", this.obj).subscribe((res) => {

      this.loadAPIcall=false;
      if (!res) { return; }
      if (res.code === GigsumoConstants.SUCESSCODE &&  res.data != null && res.data.candidateList != null) {

          const afterKey = res.data.searchAfterKey && res.data.searchAfterKey[0];
          const resData = res.data.candidateList;

          if(this.responseAfterkey === afterKey || resData.length === 0){
            this.responseStopScroll = true;
          }

          const data = resData.map(ele => ({
            ...ele,
            user: {
              ...ele.user,
              photo: ele.user.photo != null ? AppSettings.photoUrl + ele.user.photo : null
            }
          }));
          if (this.responseAfterkey !== afterKey) {
            const currentData = this.response.getValue();
            const newData = data.filter(newItem=>!currentData.some(currentItem=>currentItem.candidateId === newItem.candidateId))
            const combine = [...this.response.getValue() , ...newData];

          this.response.next(combine);
          }

          this.responseAfterkey = afterKey;

          this.feaCandiCount = resData.length;

          if (res.data.totalCandidates != undefined && res.data.totalCandidates != null) {
            this.totalcandidates = res.data.totalCandidates;
            this.provider.setCount(this.totalcandidates , "FeaturedCandidateComponent");
          }

          if (res.data.findAll) {
            this.obj.findAll = true;
            this.obj.pageNumber = 0;
          } else {
            this.obj.findAll = false;
          }

          if (res.data.candidateList === null || res.data.candidateList.length === 0){
            this.resultContent = 'NULL';
          }

      }
      else if (res.code == '99999') {
        this.response.next([]);
      }

    }, (error) => {
      this.loadAPIcall = false;
    })
  }

  modelopen(data, show, candiid) {
    let dataPass: any = {};
    dataPass.data = data.getValue();
    dataPass.singleCandiF = show;
    dataPass.id = candiid;
    dataPass.menu = this.headerTitle || this.widgetDesc || 'Featured Candidates';
    dataPass.master = this.page;
    dataPass.masterMenu = this.inputData;
    dataPass.widgetName = "FeaturedCandidateComponent";
    dataPass.count = this.totalCount;
    // console.log("datapasss",dataPass)
    this.router.navigate(['suggestions'], { queryParams: dataPass })
  }



  async redirect(val) {
    // Route reuse is disabled per-navigation inside navigateWithFreshRoute; the
    // old inline override here leaked to the whole session.
    if (val.createdBy != localStorage.getItem('userId') && val.isViewed == false && this.userType != 'JOB_SEEKER') {

      // const userData = await this.planService.UPDATE_USERDETAILS("RESUME_VIEWS");
      // if (userData.isExpired ) {
      //   let availablePoints = null;
      //   let actualPoints = null;
      //   let utilizedPoints = null;
      //   userData.userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
      //     if (ele.benefitKey == 'RESUME_VIEWS') {
      //       availablePoints = ele.available
      //       actualPoints = ele.actual
      //       utilizedPoints = ele.utilized
      //     }
      //   })
      //   this.planService.expiredPopup("RESUME_VIEWS", "PAY", null, null, null, availablePoints, actualPoints, utilizedPoints);

      //   return;
      // }
     // else {
        this.updateView(val);
     // }
    }
    else{
       navigateWithFreshRoute(this.router, ["newcandidates"], { queryParams: {candidateId : val.candidateId , tabName:'profileSummary' , From : 'FEATURED_CANDIDATE'} });
    }
  }


  updateView(val) {
       this.candidateService.updateCandidateViewed(val).subscribe((res) => {
        this.util.stopLoader();
          if(res.code==="00000"){
            navigateWithFreshRoute(this.router, ["newcandidates"], { queryParams: {candidateId : val.candidateId , tabName:'profileSummary' , From : 'FEATURED_CANDIDATE'} });
          }
      }, err => {
        this.util.stopLoader();
      });

  }

  openModalWithComponent() {
    // const initialState: NgbModalOptions = {
    //   backdrop: 'static',
    //   keyboard: false,
    //   size: "open"
    // };
    // this.bsModalRef = this.modalService.show(CreditModelComponent, { initialState });
    // this.bsModalRef.content.closeBtnName = 'Close';
    //let data:any={}; data.sufficient=true; this.router.navigate(["checkout"], { queryParams: data });


    const initialState: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: "open"
    };
    this.bsModalRef = this.modalService.show(CreditModelComponent, initialState);
  }
  currentPage: Number;
  pagecount(event) {
    this.configlist.currentPage = event;
    this.page = event;
    this.obj.pageNumber = this.page - 1;
    this.currentPage = this.page - 1
    this.jobsApi();
  }

  getSingleCandi(candiId, clickable) {
    if (candiId != null) {
      this.apiService.query("candidates/findCandidateById/" + candiId).subscribe((res) => {
        this.sugges = res.data.candidateData;
        if (clickable && this.click == true) {
          this.modelopen(this.sugges, true, candiId)
        }


      });

    }
  }

  onScrollDown(){
    if (!this.responseStopScroll && this.obj.searchAfterKey != this.responseAfterkey) {
      this.obj.searchAfterKey = this.responseAfterkey === null ? null
      : [this.responseAfterkey];
      this.jobsApi();
    }
  }
}
